import { render, staticRenderFns } from "./AlternativeContractEdit.vue?vue&type=template&id=b3cc34ce&"
import script from "./AlternativeContractEdit.vue?vue&type=script&lang=js&"
export * from "./AlternativeContractEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports